import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { showPopup } from './PopupLinkActions';

export class PopupLink extends Component {
    static propTypes = {
        url: PropTypes.string.isRequired,
        children: PropTypes.node.isRequired,
        openPopupLink: PropTypes.func.isRequired,
        showPopupConfig: PropTypes.object
    };

    handleOnClick = event => {
        const { openPopupLink, showPopupConfig } = this.props;
        return openPopupLink(event, showPopupConfig);
    };

    render() {
        const { children, url, ...props } = this.props;

        // fix react validation warning, but allow all other passthrough props.
        delete props.showPopupConfig;
        delete props.openPopupLink;

        return (
            <a
                href={url}
                data-automation-id="popUp"
                target="_blank"
                onClick={this.handleOnClick}
                {...props}
            >
                {children}
            </a>
        );
    }
}

export const mapStateToProps = () => ({});

export const mapDispatchToProps = (dispatch) => ({
    openPopupLink(event, showPopupConfig) {
        dispatch(showPopup(event, showPopupConfig));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(PopupLink);
